import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Status } from '../configs/status';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  ADMIN_PATH = `/admin`;
  CATEGORY_PATH = `/categories`;

  constructor(private http: HttpService) {}

  getCategories(params: object = {}): Observable<any> {
    return this.http.get(`${this.CATEGORY_PATH}`, params);
  }

  getAdminCategories(params: object = {}): Observable<any> {
    return this.http.get(`${this.ADMIN_PATH}${this.CATEGORY_PATH}`, params);
  }

  postAdminCategories(body: object = {}): Observable<any> {
    return this.http.post(`${this.ADMIN_PATH}${this.CATEGORY_PATH}`, body);
  }

  getCategoryById(id, params: object = {}): Observable<any> {
    return this.http.get(`${this.CATEGORY_PATH}/${id}`, params);
  }

  getAdminCategoryById(id, params: object = {}): Observable<any> {
    return this.http.get(`${this.ADMIN_PATH}${this.CATEGORY_PATH}/${id}`, params);
  }

  patchAdminCategory(id, body: object = {}): Observable<any> {
    return this.http.patch(`${this.ADMIN_PATH}${this.CATEGORY_PATH}/${id}`, body);
  }

  deleteAdminCategory(id): Observable<any> {
    return this.http.delete(`${this.ADMIN_PATH}${this.CATEGORY_PATH}/${id}`);
  }

  getCategoriesByFlowId(flowId, params: object = {}): Observable<any> {
    return this.http.get(`${this.CATEGORY_PATH}/${flowId}/available`, params);
  }
}
